import {
  deriveKeyFromPassword,
  setAdminCryptoKey,
  clearAdminCryptoKey,
} from './adminCrypto'

export const ADMIN_EMAIL = 'josh@letlois.com'

export async function checkAdminCredentials(
  email: string,
  password: string,
): Promise<boolean> {
  if (email.toLowerCase().trim() !== ADMIN_EMAIL) return false
  // Compare against known password by hashing both and comparing
  const expectedHash = await hashPassword('Br@wn$Br41ns!2025')
  const inputHash = await hashPassword(password)
  return inputHash === expectedHash
}

async function hashPassword(password: string): Promise<string> {
  const msgBuffer = new TextEncoder().encode(password)
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
}

export const ADMIN_SESSION_KEY = 'bvb_admin_session'

export async function setAdminSession(password: string) {
  sessionStorage.setItem(ADMIN_SESSION_KEY, btoa('authenticated:' + Date.now()))
  // Derive and store crypto key in memory for this session
  const key = await deriveKeyFromPassword(password)
  setAdminCryptoKey(key)
}

export function getAdminSession(): boolean {
  const val = sessionStorage.getItem(ADMIN_SESSION_KEY)
  if (!val) return false
  try {
    return atob(val).startsWith('authenticated:')
  } catch {
    return false
  }
}

export function clearAdminSession() {
  sessionStorage.removeItem(ADMIN_SESSION_KEY)
  clearAdminCryptoKey()
}
